import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Wraps several `LanguageButtonComponents` into a single unit. */
@Component({
  selector: 'plugins-multilanguage-label-wrapper',
  imports: [CommonModule],
  template: `
    <div [ngClass]="{ wrapper: true, active }">
      <ng-content />
    </div>
  `,
  styleUrl: './label-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultilanguageLabelWrapperComponent {
  @Input() active = false;
}
